import React from 'react';
import axios from '../../requesters/axios';
import Swal from 'sweetalert2';

import { CHECK_NON_FORFAIT_TOKEN_FAILURE, CHECK_NON_FORFAIT_TOKEN_SUCCESS, STOP_CHECKOUT_LOADING, SAVE_QUERY_PARAMS } from './types';
import { LOAD_ITEMS_SHOPPING_CART } from '../../components/shoppingCart/actions'
import { addToCart } from './services/actions';

import { GET_CAR_MAKE_SUCCESS, SHOW_CAR_MAKE_MODAL } from '../../actionTypes/make';

import {
  HEADER_ERROR,
  ZIPCODE_MISSING,
  MAKE_MISSING,
  MODEL_MISSING,
  HEADER_SUCCESS,
  GENERIC_SUCCESS
} from '../../constants/messages';
import { apiErrorHandler } from '../../errors';

export function checkNonForfaitToken(token) {
  return (dispatch) => {
    axios.post(`/nonForfaitToken`,
      {
        token
      })
      .then((response) => {
        const { status, budget, token, autocareBudget } = response.data;
        dispatch({
          type: CHECK_NON_FORFAIT_TOKEN_SUCCESS,
          payload: {
            status,
            token,
            budget,
            autocareBudget
          }
        });

        dispatch({
          type: LOAD_ITEMS_SHOPPING_CART,
          payload: {
            budget
          }
        });
      })
      .catch((error) => {
        dispatch({
          type: CHECK_NON_FORFAIT_TOKEN_FAILURE,
          payload: {
            error,
            status, //eslint-disable-line
          }
        });
      });
  }
}

export function stopCheckoutLoading() {
  return (dispatch) => {
    dispatch({
      type: STOP_CHECKOUT_LOADING,
    });
  };
}

export function saveQueryParams(params) {
  return (dispatch) => {
    
    dispatch({
      type: SAVE_QUERY_PARAMS,
      queryParams: params
    });
    
  };
}

export function fetchServiceAndAddToCart(id) {
  return (dispatch) => {
    axios.get(`/services/${id}`)
      .then(response => {
        dispatch(addToCart(response.data));
      })
      .catch((error) => { });
  };
}

export function checkQueryParams(queryParams, cb = () => { }) {
  return (async dispatch => {
    const { autocare: autocareEmailHash, plate, make, model, engine } = queryParams;
    const redirect = () => window.location.assign('https://www.bubocar.com/landing-solicitud-syrsa/');//TODO: JOSELITO

    if (!autocareEmailHash) {
      //redirect();
    } else {
      let queryParamsToCombine = {}

      /* BEGIN AUTOCARE CHECK */
      try {
        const { data: autocareResponse } = await axios.get(`/autocare/${autocareEmailHash}`)
        queryParamsToCombine.autocare = autocareResponse.emailHash;
      } catch (error) {
        if (error && error.response && error.response.status === 404) {
          // Invalid autocareEmailHash
          redirect();
        } else {
          apiErrorHandler(error)
        }
      }
      /* END AUTOCARE CHECK */
      if (queryParamsToCombine.autocare) {
        if (plate) {
          /* BEGIN PLATE CHECK */
          try {
            const { data: plateResponse } = await axios.get(`/cars/plate/${plate.toUpperCase()}`);
            queryParamsToCombine = {
              ...queryParamsToCombine,
              ...plateResponse,
            };

            // The car is valid and we set its data in the queryParams
            dispatch(saveQueryParams({ ...queryParams, ...queryParamsToCombine }));

            try {
              const { data: currentMake } = await axios.get(`/makes/car/plate/${plate.toUpperCase()}`)
              dispatch({
                type: GET_CAR_MAKE_SUCCESS,
                payload: {
                  currentMake,
                }
              })
            } catch (err) {
              console.error("Error getting the currentMake: ", err)
            }


          } catch (error) {
            if (error && error.response && error.response.status === 404) {
              // The car is new to the database
              dispatch(saveQueryParams(queryParams)); // Save the current query params for later
              dispatch({
                type: SHOW_CAR_MAKE_MODAL,
              })
            } else {
              apiErrorHandler(error)
            }
          }
          /* END PLATE CHECK */
        } else {
          redirect()
        }
      }
    }

  });
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/actions.js